import itMessages from '../locales/it-it.json';

const ItLang = {
  messages: {
    ...itMessages,
  },
  locale: 'it-IT',
};
export default ItLang;
